import {
    createStyles,
    FormControlLabel,
    IconButton,
    makeStyles,
    Radio,
    RadioGroup,
} from "@material-ui/core";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import * as React from "react";

import { Divider, RelodeTheme, SortOption, Text } from "..";
import { TimesIcon } from "../../assets/icons";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            header: {
                display: "flex",
                justifyContent: "space-between",
            },
            paperAnchorTop: {
                height: "100%",
            },
            filterTitle: {
                margin: theme.spacing(2),
            },
            filters: {
                margin: theme.spacing(2),
                flexGrow: 1,
            },
            keywordInput: {
                margin: theme.spacing(1, 0, 2, 0),
            },
            radioButton: {
                justifyContent: "space-between",
            },
            radioGroup: {
                padding: "16px",
            },
        }),
    { name: "SortMobile" }
);

interface SortMobileProps {
    isOpen: boolean;
    handleIsOpen: (isOpen: boolean) => void;
    searchCriteria: any;
    sortOptions: SortOption[];
    handleRequestSort: (field: string, direction: SortDir) => void;
}
export const SortMobile = (props: SortMobileProps) => {
    const classes = useStyles({});
    const {
        searchCriteria,
        isOpen,
        handleIsOpen,
        sortOptions,
        handleRequestSort,
    } = props;

    const [currentSortSelection, setCurrentSortSelection] =
        React.useState<string>();

    React.useEffect(() => {
        const sortTitle = sortOptions.find(
            x =>
                x.field === searchCriteria.sortField &&
                x.direction === searchCriteria.sortDir
        )?.title;
        setCurrentSortSelection(sortTitle);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchCriteria]);

    const handleSortClick = (value: string) => {
        const sortOption = sortOptions.find(x => x.title === value);
        handleRequestSort(sortOption.field, sortOption.direction);
        handleIsOpen(false);
    };

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={isOpen}
            onClose={() => handleIsOpen(false)}
            onOpen={() => handleIsOpen(true)}
            classes={{ paperAnchorTop: classes.paperAnchorTop }}
        >
            <div className={classes.header}>
                <Text variant="h3" className={classes.filterTitle}>
                    sort by
                </Text>
                <IconButton onClick={() => handleIsOpen(false)}>
                    <TimesIcon color="primary" />
                </IconButton>
            </div>
            <Divider />
            <RadioGroup
                defaultValue={currentSortSelection}
                aria-label="mail folder"
                name="mailFolder"
                onChange={e => handleSortClick(e.target.value)}
                className={classes.radioGroup}
            >
                {sortOptions.map((sortOption, i) => (
                    <FormControlLabel
                        key={i}
                        value={sortOption.title}
                        labelPlacement="start"
                        control={<Radio color="primary" />}
                        label={sortOption.title}
                        className={classes.radioButton}
                    />
                ))}
            </RadioGroup>
        </SwipeableDrawer>
    );
};
